import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./login.css";

const LoginSignup = () => {
  const [action, setAction] = useState("login");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [strength, setStrength] = useState(0);
  const navigate = useNavigate();

  const checkStrength = (pass) => {
    let s = 0;
    if (pass.length > 5) s += 25;
    if (/[A-Z]/.test(pass)) s += 25;
    if (/[0-9]/.test(pass)) s += 25;
    if (/[^A-Za-z0-9]/.test(pass)) s += 25;
    setStrength(s);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!email || !password || (action === "signup" && !username)) {
      setMessage("Please fill in all required fields.");
      return;
    }

    try {
      const res = await axios.post(
        "https://vortexnetowrknew.co.uk/php-backend/auth.php",
        { action, username, email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      const data = res.data;

      if (data.status === "success") {
        if (action === "login") {
          localStorage.setItem("user", JSON.stringify(data.user));
          navigate("/");
          window.location.reload();
        } else {
          setAction("login");
          setMessage("Signup successful. Please log in.");
        }
      } else {
        setMessage(data.message || "Error occurred");
      }
    } catch (err) {
      setMessage("Server error");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="tabs">
          <button
            className={action === "login" ? "active" : ""}
            onClick={() => setAction("login")}
          >
            Login
          </button>
          <button
            className={action === "signup" ? "active" : ""}
            onClick={() => setAction("signup")}
          >
            Sign Up
          </button>
        </div>

        <form onSubmit={handleSubmit} className="form">
          {action === "signup" && (
            <input
              type="text"
              placeholder="Username"
              value={username}
              name="username"
              autoComplete="username"
              onChange={(e) => setUsername(e.target.value)}
            />
          )}

          <input
            type="email"
            placeholder="Email"
            value={email}
            name="email"
            autoComplete="email"
            onChange={(e) => setEmail(e.target.value)}
          />

          <div className="password-box">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              name="password"
              autoComplete={action === "signup" ? "new-password" : "current-password"}
              onChange={(e) => {
                setPassword(e.target.value);
                checkStrength(e.target.value);
              }}
            />
            <span onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? "Hide" : "Show"}
            </span>
          </div>

          {action === "signup" && (
            <div className="strength-bar">
              <div style={{ width: `${strength}%` }} />
            </div>
          )}

          {message && <p className="message">{message}</p>}

          <button className="submit-btn">
            {action === "login" ? "Login" : "Create Account"}
          </button>
        </form>

        <div className="switch">
          {action === "login" ? (
            <p>
              No account? <span onClick={() => setAction("signup")}>Sign Up</span>
            </p>
          ) : (
            <p>
              Have an account? <span onClick={() => setAction("login")}>Login</span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginSignup;